import { defineSlotRecipe } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/react/anatomy';

const createBrandParts = () => ({
  root: {
    borderCollapse: 'separate',
    borderSpacing: 0,
    overflow: 'hidden',
  },
  header: {
    bg: '#CED5DB',
    '& th:first-of-type': {
      borderTopLeftRadius: 'md',
    },
    '& th:last-of-type': {
      borderTopRightRadius: 'md',
    },
  },
  columnHeader: {
    color: 'black',
    fontSize: 'sm',
    fontWeight: '400',
    paddingBottom: 5,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 5,
    textTransform: 'none',
  },
  body: {
    bg: 'white',
    color: 'black',
    fontSize: 'sm',
    fontWeight: '400',
    lineHeight: 'shortest',
  },
  row: {
    '&:last-of-type td:first-of-type': {
      borderBottomLeftRadius: 'md',
    },
    '&:last-of-type td:last-of-type': {
      borderBottomRightRadius: 'md',
    },
  },
  cell: {
    paddingBottom: 5,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 5,
    lineHeight: 'shorter',
    borderBottom: '1px solid',
    borderBottomColor: 'gray.300',
    '&:first-of-type': {
      borderLeft: '1px solid',
      borderLeftColor: 'gray.300',
    },
    '&:last-of-type': {
      borderRight: '1px solid',
      borderRightColor: 'gray.300',
    },
  },
  footer: {
    bg: 'white',
    color: 'black',
    cell: {
      paddingBottom: 6,
      paddingTop: 6,
    },
  },
});

const brand = createBrandParts();

const crudBrand = {
  ...brand,
  root: {
    ...brand.root,
    '& textarea, & input, & .input-like': {
      border: 'none',
      padding: 0,
      bg: 'transparent',
      _focus: {
        focusRing: 'none',
        border: 'none',
        boxShadow: 'none',
      },
    },
    '& select': {
      border: 'none',
      padding: 0,
      paddingLeft: '27px',
      bg: 'transparent',
      _focus: {
        focusRing: 'none',
        border: 'none',
        boxShadow: 'none',
      },
    },
    '& .chakra-native-select__indicator': {
      right: 'inherit',
      left: 0,
    },
    '& .ck.ck-content.ck-editor__editable': {
      minHeight: '160px',
    },
  },
  cell: {
    ...brand.cell,
    paddingBottom: 2,
    paddingTop: 2,
    borderRight: '1px solid',
    borderRightColor: 'gray.75',
    '&:first-of-type': {
      width: '25%',
    },
    '&:nth-of-type(2)': {
      width: '35%',
    },
    '&:nth-of-type(3)': {
      width: '20%',
    },
    '&:nth-of-type(4)': {
      width: '20%',
    },
  },
  header: {
    bg: 'gray.75',
  },
  row: {
    borderBottom: '1px solid',
    borderBottomColor: 'gray.75',
    borderLeft: '1px solid',
    borderLeftColor: 'gray.75',
    borderRight: '1px solid',
    borderRightColor: 'gray.75',
    minHeight: '40px',
  },
};

const brandStriped = {
  ...brand,
  body: {
    ...brand.body,
    row: {
      '&:nth-of-type(even)': {
        bg: 'gray.70',
      },
    },
  },
};

const simple = {
  cell: {
    borderBottom: '1px solid',
    borderColor: 'gray.200',
    fontSize: 'sm',
  },
  columnHeader: {
    borderColor: 'gray.200',
    color: 'black',
    textTransform: 'none',
  },
};

export default defineSlotRecipe({
  slots: tableAnatomy.keys(),
  variants: {
    variant: {
      brand,
      crudBrand,
      'brand-striped': brandStriped,
      simple,
    },
  },
  defaultVariants: {
    variant: 'brand',
  },
});
